import './FilterTable.css'
import React, { useState } from 'react';
import InputLabel from '@mui/material/InputLabel';


import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import './DateFilter.css'


export default function SecondaryDatePickerFilter() {
    const [initialExpirate, setinitialExpirate] = useState(null);
    const [finalExpirate, setfinalExpirate] = useState(null);
    return (
        <div className="DateFilterContainer">
            <InputLabel id="demo-simple-select-standard-label">Data inicial</InputLabel>
            <DatePicker id="datePicker"
                selected={initialExpirate}
                onChange={date => setinitialExpirate(date)}
                dateFormat='dd/MM/yyyy'
            >
            </DatePicker>
            <InputLabel id="demo-simple-select-standard-label">Data final</InputLabel>
            <DatePicker id="datePicker"
                selected={finalExpirate}
                onChange={date => setfinalExpirate(date)}
                dateFormat='dd/MM/yyyy'
            >
            </DatePicker>
        </div>
    )
}